import {requestRemoteData} from '../../API/api';

const FAVORITE_ENDPOINT = 'account/favorites';

export const addToFavorites = (productCode): Promise<void> => {
  return requestRemoteData(
    FAVORITE_ENDPOINT,
    { method: 'POST', queryParams: { cod_articulo: productCode } }
  );
};

export const removeFromFavorites = (productCode): Promise<void> => {
  return requestRemoteData(
    FAVORITE_ENDPOINT,
    { method: 'DELETE', queryParams: { cod_articulo: productCode } }
  );
};
